import css from "./css/errorPage.module.css"

const ErrorPage = () => {
  return (
    <main className={css.page}>
      <p className={css.code}>404</p>
      <h1 className={css.title}>找不到頁面</h1>
      <p className={css.message}>
        抱歉，您所瀏覽的頁面暫時無法使用。網站服務暫停中，請稍後再試。
      </p>
      <p className={css.messageEn}>
        Sorry, this page is temporarily unavailable. The site is currently
        paused — please check back later.
      </p>
    </main>
  )
}

export default ErrorPage
